import { Config } from '@backstage/config';

export const isCognitiveMinutesAvailable = (config: Config) => {
  const minutesConfig = config.getOptionalConfig('platt.cognitiveMinute');
  return !!minutesConfig;
}
